import { signal, onCleanup } from "zyra";
export function CodeBlock(props: { text: string; language: string }) {
  const state = signal("Copy");
  let timer: ReturnType<typeof setTimeout>;
  onCleanup(() => clearTimeout(timer));
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(props.text);
      state.value = "Copied!";
    } catch {
      state.value = "Select to copy";
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      state.value = "Copy";
    }, 2200);
  };
  const highlighted = props.text
    .split(
      /('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|\b(?:import|from|const|let|return|function|await|export|type|if|new|true|false)\b|\/\/[^\n]*)/g,
    )
    .map((part, i) =>
      i % 2 ? (
        <span
          class={
            part.startsWith("//")
              ? "token-comment"
              : /^['"]/.test(part)
                ? "token-string"
                : "token-keyword"
          }
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  return (
    <div class="code-block">
      <div class="code-toolbar">
        <span>
          <i />
          {props.language || "code"}
        </span>
        <button onClick={() => void copy()} aria-label={state.value + " code"}>
          {state.value}
        </button>
      </div>
      <pre tabIndex={0}>
        <code>{highlighted}</code>
      </pre>
    </div>
  );
}
